<template>
  <div class="register">
    <el-tabs v-model="componentName" stretch>
      <el-tab-pane label="企业注册" name="employeeRegister" />
      <el-tab-pane label="专家注册" name="expertRegister" />
    </el-tabs>

    <employee-register
      v-if="componentName === 'employeeRegister'"
      key="employee"
      class="m-t-10"
    />
    <expert-register
      v-if="componentName === 'expertRegister'"
      key="expert"
      class="m-t-10"
    />
  </div>
</template>

<script>
// 组件
import EmployeeRegister from '@/views/register/components/Employee.vue'
import ExpertRegister from '@/views/register/components/Expert.vue'

export default {
  name: 'Register',

  components: {
    EmployeeRegister,
    ExpertRegister
  },

  data() {
    return {
      componentName: 'employeeRegister'
    }
  },

  methods: {
    handleClick() {}
  }
}
</script>

<style lang="scss" scoped>
.register {
  width: 1200px;
  background-color: $white-color;
  padding: 40px 350px;
  box-sizing: border-box;
  text-align: left;

  ::v-deep .el-tabs {
    .el-tabs__item {
      font-size: 20px;
      color: $text-second-color;

      &.is-active {
        color: $primary-color;
      }
    }
  }
}
</style>
